@if (mode() === 'icon') {
  <fa-duotone-icon [class]="iconClass()" [icon]="icon()"></fa-duotone-icon>
} @else {
  <span [class]="textClass()">{{ ping() }} ms</span>
}
